import { ROUTE_HOMEPAGE } from '@1bill-app/constants';
import { RewardQuery } from '@1bill-app/services/reward/reward.query';
import { RewardService } from '@1bill-app/services/reward/reward.service';
import { Component, OnInit } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { filter, map, mergeMap } from 'rxjs/operators';

interface Achievements {
  title: string;
  desc: string;
  points: number;
  icon: string;
  completed: boolean;
}

@Component({
  selector: 'app-achievements',
  templateUrl: './achievements.page.html',
  styleUrls: ['./achievements.page.scss'],
})
export class AchievementsPage implements OnInit {
  homePage = ROUTE_HOMEPAGE;
  isLoading$ = this.rewardQuery.isLoading$.pipe(map(res => res))

  rewards$ = this.rewardQuery.rewards$.pipe(
    map(rewards => rewards.filter(reward => reward.showBadge === 1)),
  );
  constructor(private rewardService: RewardService,
    public rewardQuery: RewardQuery,
    public logger: NGXLogger
  ) { }

  ngOnInit() {
    this.rewardService.getRewards().subscribe(res => {
      this.logger.debug('rewardService', res);
    });
  }

}
